import {ReactiveController, ReactiveControllerHost} from "lit";
import {translate as _t} from "lit-translate";

export class TranslationController implements ReactiveController {
    public constructor(private host: ReactiveControllerHost) {
        host.addController(this);
    }

    public hostConnected() {
        window.addEventListener('langChanged', this.handleLangChanged);
    }

    public hostDisconnected() {
        window.removeEventListener('langChanged', this.handleLangChanged);
    }

    public translate(key: string, vars?: {}) {
        return _t(key.substring(8), vars);
    }

    private handleLangChanged = () => {
        this.host.requestUpdate();
    }
}